const FINANCE_TERMS = [/money/i, /cash/i, /finance/i, /stocks?/i, /portfolio/i, /profit/i];
const QUANTUM_TERMS = [/quantum/i, /physics/i, /technology/i, /tech/i, /ai/i, /ml/i];
const DISGUST_TERMS = [/vegetable/i, /菜/, /salad/i, /greens?/i, /broccoli/i];

export function detectFinance(text: string): boolean {
  return FINANCE_TERMS.some((pattern) => pattern.test(text));
}

export function detectQuantum(text: string): boolean {
  return QUANTUM_TERMS.some((pattern) => pattern.test(text));
}

export function detectDisgust(text: string): boolean {
  return DISGUST_TERMS.some((pattern) => pattern.test(text));
}
